module.exports = __webpack_public_path__ + "assets/359377e83100aba6e8187f2a0242c494.mp3";